import auth from "../middleware/auth";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../../views/protected/DashboardPage"),
    meta: {
      title: "Admin Dashboard",
      middleware: [auth],
      layout: () => import("../../layouts/protected"),
    },
  },
];

export default routes;
